// Action Types
export const FETCH_SELF_FINANCIALS_GIQ_REQUEST =
  "FETCH_SELF_FINANCIALS_GIQ_REQUEST";
export const FETCH_SELF_FINANCIALS_GIQ_SUCCESS =
  "FETCH_SELF_FINANCIALS_GIQ_SUCCESS";
export const FETCH_SELF_FINANCIALS_GIQ_FAILURE =
  "FETCH_SELF_FINANCIALS_GIQ_FAILURE";

// Action Creators
export const fetchSelfFinancialsGiqRequest = (ticker) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_SELF_FINANCIALS_GIQ_REQUEST,
      payload: ticker,
    });
  };
};
export const fetchSelfFinancialsGiqSuccess = (products) => ({
  type: FETCH_SELF_FINANCIALS_GIQ_SUCCESS,
  payload: products,
});
export const fetchSelfFinancialsGiqFailure = (error) => ({
  type: FETCH_SELF_FINANCIALS_GIQ_FAILURE,
  payload: error,
});
